import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './VolunteerTests.css'
import LoadingScreen from '../components/LoadingScreen'

const VolunteerTests = () => {
  const [tests, setTests] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [search, setSearch] = useState('')
  const history = useHistory()

  useEffect(() => {
    const token = localStorage.getItem('access_token')
    if (!token) {
      history.push('/login')
      return
    }

    const userData = JSON.parse(localStorage.getItem('user') || '{}')
    if (userData.role !== 'volunteer') {
      history.push('/login')
      return
    }

    fetchTests()
  }, [history])

  const fetchTests = async () => {
    try {
      const token = localStorage.getItem('access_token')
      const response = await fetch('/api/volunteer/tests', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setTests(data.tests || [])
      } else {
        setError('Failed to load tests')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  const filteredTests = tests.filter(test => 
    test.title.toLowerCase().includes(search.toLowerCase())
  )

  if (loading) {
    return <LoadingScreen message="Loading Tests" />
  }

  return (
    <div className="volunteer-tests-container">
      <header className="page-header">
        <h1>Available Tests</h1>
        <button 
          className="back-button"
          onClick={() => history.push('/volunteer-dashboard')}
        >
          ← Back to Dashboard
        </button>
      </header>

      <main className="tests-main">
        <div className="search-section">
          <input
            type="text"
            placeholder="Search tests..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search-input"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="tests-grid">
          {filteredTests.length > 0 ? (
            filteredTests.map((test) => (
              <div key={test.id} className="test-card">
                <h3>{test.title}</h3>
                <p className="test-description">{test.description || 'No description'}</p>
                <div className="test-stats">
                  <span>Duration: {test.duration_minutes} min</span>
                  <span>Attempts: {test.total_attempts || 0}</span>
                </div>
                <button
                  className="view-button"
                  onClick={() => history.push(`/volunteer/test/${test.id}`)}
                >
                  View Details
                </button>
              </div>
            ))
          ) : (
            <p className="no-tests">No tests available</p>
          )}
        </div>
      </main>
    </div>
  )
}

export default VolunteerTests

